export default __webpack_public_path__ + "static/media/Snd_J_Starts.b82c2335.mp3";